import { useEffect, useRef, useState } from "react";
import { CarouselArrow } from "~/assets/icons/CarouselArrow";
import { GetLargeUrl } from "~/utils/images";

//Based on this: https://play.tailwindcss.com/w3I0LX5oqw
export const ImageCarousel = ({
  images,
  selectedImageUrl,
  soldOut,
  style,
}: {
  images: string[];
  selectedImageUrl: string | null;
  soldOut: boolean;
  style: React.CSSProperties;
}) => {
  const refs = useRef<(HTMLDivElement | null)[]>([]);
  const containerRef = useRef<HTMLDivElement>(null);
  const activeIndex = selectedImageUrl ? images.findIndex((image) => image === selectedImageUrl) : 0;
  const [currentIndex, setCurrentIndex] = useState(activeIndex);

  useEffect(() => {
    refs.current = refs.current.slice(0, images.length);
  }, [images.length]);

  useEffect(() => {
    if (refs.current[activeIndex]) {
      containerRef.current?.scrollTo({
        left: refs.current[activeIndex]?.offsetLeft,
      });
    }
  }, [activeIndex]);

  const handleScroll = () => { if (containerRef.current) { const scrollLeft = containerRef.current.scrollLeft; const containerWidth = containerRef.current.offsetWidth; const newIndex = Math.round(scrollLeft / containerWidth); if (newIndex !== currentIndex) { setCurrentIndex(newIndex); } } };

  return (
    <div className="mx-auto flex w-fit flex-row gap-x-6" style={style}>
      <div className="flex flex-col relative">
        <div
          ref={containerRef}
          className="no-scrollbar edge-mask flex snap-x snap-mandatory overflow-auto"
          onScroll={handleScroll}

        >
          {images.map((image, index) => {
            return (
              <div
                key={image}
                className="relative min-w-full snap-center snap-always"
                ref={(el) => (refs.current[index] = el)}
              >
                <img
                  src={GetLargeUrl(image)}
                  className="rounded border-[1px] border-[#0E0F0F1A]"
                />
              </div>
            );
          })}
        </div>
        {soldOut && (
          <div className="absolute left-0 top-0 z-10 bg-[#E3DACC] px-2 py-2 font-bold">
            Uppselt
          </div>
        )}
        <div className="absolute bottom-2 right-2 md:right-[56px] flex flex-row items-center gap-2">
          <div className="cursor-pointer" onClick={() => { if (currentIndex > 0) { setCurrentIndex(currentIndex - 1); containerRef.current?.scrollTo({ left: refs.current[currentIndex - 1]?.offsetLeft, behavior: "smooth" }); } }} >
            <CarouselArrow isActive={currentIndex > 0} direction="left" />
          </div>
          <div className="cursor-pointer" onClick={() => { if (currentIndex < images.length - 1) { setCurrentIndex(currentIndex + 1); containerRef.current?.scrollTo({ left: refs.current[currentIndex + 1]?.offsetLeft, behavior: "smooth" }); } }} >
            <CarouselArrow isActive={currentIndex < images.length - 1} direction="right" />
          </div>
        </div>
      </div>
    </div>
  );
};
